import styled from 'styled-components';

export default styled.div`
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 15px;
`;
